export const share = {
  name: "share" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25" fill="currentColor"><path fill-rule="evenodd" d="M18 4.4a2.1 2.1 0 1 0 0 4.2 2.1 2.1 0 0 0 0-4.2Zm-3.9 2.1a3.9 3.9 0 1 1 .892 2.483l-6.188 2.652a3.913 3.913 0 0 1 0 1.73l6.188 2.652a3.9 3.9 0 1 1-.796 1.617l-6.188-2.652a3.9 3.9 0 1 1 0-4.965l6.188-2.652A3.915 3.915 0 0 1 14.1 6.5ZM5 10.4a2.1 2.1 0 1 0 0 4.2 2.1 2.1 0 0 0 0-4.2Zm13 6a2.1 2.1 0 1 0 0 4.2 2.1 2.1 0 0 0 0-4.2Z" clip-rule="evenodd"/></svg>`,
  keywords: ["share"],
  category: "action" as const,
};
